import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.auth.issuer,

  clientId: environment.auth.clientId,

  dummyClientSecret: '',

  redirectUri: window.location.origin,

  responseType: 'code',

  scope: 'openid profile email',

  requireHttps: false,
  showDebugInformation: false,
  disableAtHashCheck: true,
};
